import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { styleSheet } from './styles';

/**
 * A revision that reopened the round but never filed leaves no trace the advisor can see — no status
 * field records it, so without this the piece simply sits in review having submitted nothing.
 */
export const RegEdRevisionOwedCard = ({
	isRetrying,
	needsFiling,
	onRetry,
}: {
	isRetrying?: boolean;
	/** Which step is still owed, which is also what the retry will resume at. */
	needsFiling: boolean;
	onRetry?: () => void;
}) => (
	<div className={css(styleSheet.card)}>
		<div className={css(styleSheet.title)}>Submission incomplete</div>
		<div>
			{needsFiling
				? 'The review was reopened, but the submission could not be sent, so nothing reached your firm yet.'
				: 'The review was reopened, but the compliance document could not be produced, so nothing reached your firm yet.'}
		</div>
		<Button disabled={isRetrying} isLoading={isRetrying} onClick={onRetry}>
			Retry submission
		</Button>
	</div>
);
